export const whatMovesUsEn = {
  whatMovesUs_pageTitle: "What Moves Us",
  whatMovesUs_intro:
    "Jandi was born from a simple observation: Puerto Rico has talent. What it lacks is structure.",
  whatMovesUs_body:
    "We saw thousands of excellent professionals working in an informal system, without visibility or support. And we saw families losing hours searching for someone reliable to solve something at home. That moved us to build Jandi.",

  whatMovesUs_s1Title: "Trust as a starting point",
  whatMovesUs_s1Body:
    "Every provider on jandi goes through pre-verification before becoming visible. We do not publish incomplete profiles. Trust is not improvised - it is built with standards.",

  whatMovesUs_s2Title: "Built for Puerto Rico",
  whatMovesUs_s2Body:
    "We are not an adapted global platform. We are a project built from here, for here. We understand the market, the culture, and the way people work on the island.",

  whatMovesUs_s3Title: "Less friction, more resolution",
  whatMovesUs_s3Body:
    "People's time is valuable. That is why we designed the experience so solving a service is fast, clear, and simple - from the first click to payment.",

  whatMovesUs_s4Title: "Support at every step",
  whatMovesUs_s4Body:
    "If something does not go as expected, we are here. Jandi has formal support to handle any situation - we do not disappear after the connection.",

  whatMovesUs_s5Title: "A community, not just an app",
  whatMovesUs_s5Body:
    "Each provider who joins builds real reputation and visible history. We want talent in Puerto Rico to stay, grow, and be recognized.",

  whatMovesUs_quote:
    "\"Puerto Rico has talent. We want it to stay and always be at hand.\"",
};
